import React from "react"
import { Modal, Button, Flex } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
const { confirm } = Modal

export const DeleteConfirmation = ({
  visible,
  onCancel,
  onConfirm,
  title,
  content,
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false
}) => {
  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered className={styles.deleteModal} width={520} maskClosable={false}>
      <div className={styles.modalContent}>
        <Flex justify="center" align="center" className="mb-4">
          <WarningOutlinedWithBg />{" "}
        </Flex>
        <h3 className={styles.modalTitle}>{title}</h3>
        <p className={styles.modalText}>{content}</p>
        <Flex align="center" gap={10}>
          <Button onClick={onCancel} color="primary" variant="outlined" disabled={loading}>
            {cancelText}
          </Button>
          <Button type="primary" onClick={onConfirm} loading={loading} danger>
            {confirmText}
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

DeleteConfirmation.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool
}

export default DeleteConfirmation
